import React, { Button, Component, useState } from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import moment from "moment";

import getEventi from "../../services/getEventi";
import deleteEvento from "../../services/deleteEvento";
import BlackList from "../blacklist/Blacklist";

const endLine = "\n";

export default class Eventi extends React.Component {
  constructor(props) {
    super(props);

    this.pageDiv = {
      border: "1px solid #cccccc",
      padding: 10,
    };

    this.state = {};

    this.eventi = [];
    this.pageTitle = "Eventi";
  }
  async reload() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });

    try {
      this.eventi = await getEventi(username, token, "admin");

      // Verifica che sia un array
      if (!Array.isArray(this.eventi)) {
        console.error(
          "[Eventi] getEventi non ha ritornato un array:",
          this.eventi
        );
        this.eventi = [];
      }
    } catch (error) {
      console.error("[Eventi] Errore nel caricamento eventi:", error);
      alert(
        "Errore nel caricamento degli eventi: " +
          (error.message || "Errore sconosciuto")
      );
      this.eventi = [];
      this.setState({});
      return;
    }

    // Configura moment per l'italiano
    moment.locale("it");

    // Formatta il campo created_at per la visualizzazione
    this.eventi = this.eventi.map((evento) => ({
      ...evento,
      created_at: evento.created_at
        ? moment(evento.created_at).format("DD/MM/YYYY HH:mm")
        : "",
    }));

    // Ordina gli eventi dal più recente al meno recente
    this.eventi.sort((a, b) => {
      // Converte le date dal formato YYYY/MM/DD a oggetti Date per il confronto
      const parseDate = (dateStr) => {
        if (!dateStr || dateStr === "") return new Date(0); // Se non c'è data, mette alla fine

        // Gestisce diversi formati possibili
        let year, month, day;

        if (dateStr.includes("/")) {
          const parts = dateStr.split("/");
          if (parts.length === 3) {
            // Assume formato YYYY/MM/DD
            year = parseInt(parts[0]);
            month = parseInt(parts[1]);
            day = parseInt(parts[2]);
          }
        } else if (dateStr.includes("-")) {
          const parts = dateStr.split("-");
          if (parts.length === 3) {
            // Assume formato YYYY-MM-DD
            year = parseInt(parts[0]);
            month = parseInt(parts[1]);
            day = parseInt(parts[2]);
          }
        }

        // Verifica che i valori siano validi
        if (!year || !month || !day) return new Date(0);

        return new Date(year, month - 1, day); // month - 1 perché i mesi in JS sono 0-based
      };

      const dateA = parseDate(a.data);
      const dateB = parseDate(b.data);

      // Ordine decrescente: date più recenti prima
      return dateB - dateA;
    });

    this.setState({});
  }

  async componentDidMount() {
    await this.reload();
  }

  render() {
    const cookies = new Cookies();
    var headCells = [
      { id: "titolo", numeric: false, disablePadding: true, label: "Titolo" },
      { id: "data", numeric: false, disablePadding: false, label: "Data" },
      {
        id: "created_at",
        numeric: false,
        disablePadding: false,
        label: "Data creazione",
      },
      { id: "_", numeric: true, disablePadding: false, label: "" },
    ];

    this.searchCols = ["titolo", "data", "created_at"];

    return (
      <div id={Math.random()}>
        <LoadingOverlay
          active={this.state.isLoading}
          styles={{
            content: (base) => ({
              position: "relative",
              width: "100%",
              top: "200px",
            }),
          }}
          spinner
          text={"Loading your content..."}
        >
          <PageTitle
            title="Eventi"
            button="NUOVO"
            onClick={() => {
              window.location.href = "/#/app/addEvento";
            }}
          />{" "}
          <Table
            headCells={headCells}
            searchCols={this.searchCols}
            rows={this.eventi}
            orderBy="data"
            desc={true}
            onEventClick={(row) => {
              cookies.set("currentEvent", row, { path: "/" });
              window.location.href = "/#/app/editEvento";
            }}
            onDelete={async (id) => {
              if (
                window.confirm(
                  "Sei sicuro di voler eliminare questo evento?"
                ) == false
              )
                return;

              const cookies = new Cookies();
              const username = cookies.get("username", { path: "/" });
              const token = cookies.get("token", { path: "/" });
              await deleteEvento(username, token, id);
              this.reload();
            }}
          />
          <BlackList />
          {this.elementPdf ? this.elementPdf : null}
          <WaitDialog
            show={this.state.waitDialogVisible}
            key={Math.random()}
            index={this.state.index}
          />
        </LoadingOverlay>
      </div>
    );
  }
}
